<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="sayfahead m-0">
      <h1><small>İnternet Entegrasyonu</small></h1>
      <el-button-group class="YeniBtn">
        <el-button type="warning" size="small" @click="InternetModal=true">Kullanıcı Ayarları</el-button>
        <el-button type="primary" size="small" @click="TarifeModal=true">Tarifeler</el-button>
        <el-button type="success" size="small" @click="NasModal=true">Nas Listesi</el-button>
        <el-button type="info" size="small" @click="RadiusModal=true">Radius Bilgi</el-button>
      </el-button-group>
    </div>

    <el-row :gutter="24">
      <el-col :span="6">
        <NasList :Bina_id="Bina_id"></NasList>
        <h5><small>Tarife</small></h5>
        <table class="table table-sm">
          <thead>
          <tr>
            <th>Tarife Adı</th>
            <th>Hız Limiti</th>
            <th>Kota</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="t in TarifeListe">
            <td>{{t.TarifeAdi}}</td>
            <td>{{t.Hiz}}</td>
            <td>{{t.sTur}} {{t.gKota}}</td>
          </tr>
          </tbody>
        </table>
      </el-col>
      <el-col :span="18">
        <el-alert
          v-if="!TarifeListe"
          class="mt-2"
          title="Kurulum Bilgi"
          type="success"
          :closable="false"
          description="Meskenlere internet tanımlamak için Tarifeler ve Nas eklemeniz gerekmektedir.">
        </el-alert>
        <InternetKullaniciListesi v-if="TarifeListe" :Bina_id="Bina_id"></InternetKullaniciListesi>
      </el-col>
    </el-row>

    <RadiusBilgiModal :Bina_id="Bina_id" :Modal="RadiusModal" v-if="RadiusModal" @ModalOlayi="RadiusModal=false"></RadiusBilgiModal>
    <NasModal :Bina_id="Bina_id" :Modal="NasModal" v-if="NasModal" @ModalOlayi="NasModal=false"></NasModal>
    <TarifeModal :Bina_id="Bina_id" :Modal="TarifeModal" v-if="TarifeModal" @ModalOlayi="TarifeModal=false"></TarifeModal>
    <InternetKurulum :TarifeListe="TarifeListe" v-if="InternetModal" :Modal="InternetModal" @ModalOlayi="InternetModal=false" :Bina_id="Bina_id"></InternetKurulum>

  </div>
</template>

<script>
  import Yukleniyor from "../../Doc/Yukleniyor";
  import RadiusBilgiModal from "./RadiusBilgiModal";
  import NasModal from "./NasModal";
  import TarifeModal from "./TarifeModal";
  import NasList from "./NasList";
  import InternetKurulum from "./InternetKurulum";
  import InternetKullaniciListesi from "./InternetKullaniciListesi";

  export default {
    props: ['Bina_id'],
    components: {InternetKullaniciListesi, InternetKurulum, TarifeModal, NasModal, RadiusBilgiModal, Yukleniyor, NasList},
    data() {
      return {
        Mikrotik: null,
        TarifeListe: null,
        lo: false,
        RadiusModal: false,
        NasModal: false,
        TarifeModal: false,
        InternetModal: false,
      }
    },
    methods: {
      SayfaYukle() {
        this.$store.dispatch("Get", {path: '_radius/tarife/' + this.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.TarifeListe = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      }
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>
  h5 {
    padding: 5px;
    background: #eceef6;
  }
</style>




// WEBPACK FOOTER //
// src/components/Pack/Internet/Radius.vue